/**
 * Enables desktop smooth scrolling while avoiding touch, reduced-motion, and
 * theme-editor contexts. The observer keeps Lenis in sync with dynamic content.
 */
(function initializeLenis() {
  const isTouchDevice =
    window.matchMedia('(pointer: coarse)').matches || window.matchMedia('(hover: none)').matches;
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (isTouchDevice || prefersReducedMotion || !window.Lenis) {
    window.lenis = undefined;
    return;
  }

  const lenis = new Lenis({
    duration: 1.2,
    easing(t) {
      return Math.min(1, 1 - Math.pow(2, -10 * t));
    },
    orientation: 'vertical',
    gestureOrientation: 'vertical',
    smoothWheel: true,
    wheelMultiplier: 1,
    touchMultiplier: 2,
    infinite: false,
    prevent(node) {
      return Boolean(
        node.closest?.(
          '.md-form__select__country__list, .md-form__select__language__list, .md-form, .localization-form__list, select'
        )
      );
    },
  });

  function raf(time) {
    lenis.raf(time);
    window.requestAnimationFrame(raf);
  }
  window.requestAnimationFrame(raf);

  const resizeObserver = new ResizeObserver(() => lenis.resize());
  resizeObserver.observe(document.body);

  window.addEventListener('load', () => {
    window.setTimeout(() => lenis.resize(), 500);
  });

  window.lenis = lenis;

  if (window.Shopify && Shopify.designMode) {
    resizeObserver.disconnect();
    lenis.destroy();
    window.lenis = undefined;
  }
})();
